export default "__VITE_ASSET__tjVwAKco__"